import React, { Fragment } from "react";
import WithAccount, { AccountLoadStatus } from "assets/scripts/components/containers/secure/WithAccounts/WithAccount";
import callbackRequestPromise from "../CallbackRequest/async";
import { defineMessages, FormattedMessage } from "react-intl";
import track from "react-tracking";
export const messages = defineMessages({
    headerRequest: {
        id: "account.callbackRequest.header.request",
        defaultMessage: "Request a Call Back"
    },
    headerUpcoming: {
        id: "account.callbackRequest.header.upcoming",
        defaultMessage: "Upcoming Call Back"
    },
    headerReschedule: {
        id: "account.callbackRequest.header.reschedule",
        defaultMessage: "Reschedule Call Back"
    }
});
class Callback extends React.Component {
    constructor() {
        super(...arguments);
        this._isMounted = true;
        this.state = {
            CallbackRequest: null
        };
    }
    async componentDidMount() {
        this._isMounted = true;
        const { default: CallbackRequest } = await callbackRequestPromise;
        if (this._isMounted) {
            this.setState({ CallbackRequest });
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        const { props } = this;
        const { CallbackRequest } = this.state;
        return (<div className="wrapper wrapper_narrow">
				<WithAccount acctId={parseInt(props.params.id, 10)}>
					{({ loading, error, acct }) => {
            loading = loading || CallbackRequest == null;
            const reschedule = props.location.query.reschedule === "1"
                && (acct == null || acct.callbackAccount.callback != null);
            const header = reschedule ? messages.headerReschedule
                : loading || acct == null || acct.callbackAccount.callback == null ? messages.headerRequest
                    : messages.headerUpcoming;
            return (<Fragment>
								<div className="vr vr_x4">
									<h1 className="hdg js-pageHeader">
										<FormattedMessage {...header}/>
									</h1>
								</div>

								<AccountLoadStatus loading={loading} error={error}/>

								{!loading && error == null && acct != null && CallbackRequest != null && (<CallbackRequest acct={acct.callbackAccount} reschedule={props.location.query.reschedule === "1"}/>)}
							</Fragment>);
        }}
				</WithAccount>
			</div>);
    }
}
export default track({ page: "Callback" }, { dispatchOnMount: true })(Callback);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Callback/Callback.tsx